import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { BookingByTourClientDto } from '@/features/dashboard/clients/types/BookingByTourClientDto.ts';
import { getClientBookingDetailsQueryOptions } from '@/features/dashboard/clients/hooks/useGetClientBookingDetails.ts';

/**
 * Tytuł przelewu rezerwacji — backend nadaje jeden na rezerwację i przypina go
 * do wszystkich rat. Klient i rezerwacja są 1:1, więc odczyt po kliencie
 * i wyjeździe wskazuje dokładnie tę rezerwację.
 */
const useGetBookingTransferTitle = (
  clientId?: string,
  tourId?: string,
): UseQueryResult<string | null> =>
  useQuery<BookingByTourClientDto, Error, string | null>({
    ...getClientBookingDetailsQueryOptions(clientId ?? '', tourId),
    enabled: !!clientId && !!tourId,
    select: (dto) => dto.transferClientCode,
  });

export default useGetBookingTransferTitle;
